export const SERVER = process.env.REACT_APP_SERVER || ''
export const CLIENT = process.env.REACT_APP_CLIENT || ''